import { type MouseEvent as ReactMouseEvent } from "react"

import { blendColorChannel } from "./uploadedConversationsVisualizerMotion"
import { type RgbColor } from "./uploadedConversationsVisualizerParticles"

const OVERLAY_CENTER = 50
const TOOLTIP_VIEWPORT_MARGIN = 12

function clamp(value: number, min: number, max: number) {
  return Math.min(max, Math.max(min, value))
}

export function resolveBlendedColor(from: RgbColor, to: RgbColor, mix: number) {
  return {
    b: blendColorChannel(from.b, to.b, mix),
    g: blendColorChannel(from.g, to.g, mix),
    r: blendColorChannel(from.r, to.r, mix),
  }
}

export function resolveHoverPosition(event: ReactMouseEvent<SVGElement>) {
  if (typeof window === "undefined") {
    return { x: OVERLAY_CENTER, y: OVERLAY_CENTER }
  }

  return {
    x: clamp(
      event.clientX,
      TOOLTIP_VIEWPORT_MARGIN,
      Math.max(
        TOOLTIP_VIEWPORT_MARGIN,
        window.innerWidth - TOOLTIP_VIEWPORT_MARGIN,
      ),
    ),
    y: clamp(
      event.clientY,
      TOOLTIP_VIEWPORT_MARGIN,
      Math.max(
        TOOLTIP_VIEWPORT_MARGIN,
        window.innerHeight - TOOLTIP_VIEWPORT_MARGIN,
      ),
    ),
  }
}
